import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ReservationDetail} from '../../../projects/shared-lib/src/lib/models/reservation-detail';

export interface Reservations {
    reservations: ReservationDetail[];
    metadata: {
        totalElements: number;
        totalPages: number;
        page: number;
        size: number;
    };
}

@Injectable({
    providedIn: 'root'
})
export class ReservationService {
    constructor(private http: HttpClient) {
    }

    getReservations(clientId: number, params?: HttpParams): Observable<Reservations> {
        return this.http.get<Reservations>(`v1/clients/${clientId}/reservations`, {params});
    }

    getReservationToken(clientId: number, reservationId: number): Observable<string> {
        return this.http.get(`v1/clients/${clientId}/reservations/${reservationId}/token`, {responseType: 'text'});
    }

    releaseReservation(clientId: number, reservationToken: string): Observable<void> {
        return this.http.delete<void>(`v1/clients/${clientId}/reservations/${reservationToken}`);
    }

}
